<form [formGroup]="settingsForm" id="appSettingsWrapper" (ngSubmit)="onSubmit()">
  <div class="backButton" (click)="builderService.navigateBack()">
    <img src="/assets/icons/arrow-left.svg" [alt]="'Go back' | translate" />
  </div>
  <!-- Header Section -->
  <div class="header-section">
    <div>
      <p class="title">{{ 'App Basics' | translate }}</p>
      <p class="subtitle">{{ 'Manage your application\'s identity and visual branding.' | translate }}</p>
    </div>
    <button type="submit" class="saveButton" [disabled]="saving">
      {{ 'Save Changes' | translate }}
    </button>
    <!-- Tour Next Button -->
    <button *ngIf="this.builderService.getTour()" class="stacksBtn green" type="button" (click)="generalSettingsNext()">
      {{ 'Next' | translate }}
    </button>
  </div>

  <!-- Tour Instructions -->
  <div *ngIf="this.builderService.getTour()" class="generalSettingsTourHeader" style="margin-bottom: 20px;">
    <h1>{{ 'Initial Setup' | translate }}</h1>
    <p>{{ 'You can leave the below settings default for now' | translate }}</p>
  </div>

  <div class="generalContainer">

    <!-- Top Grid: App Details + Theme Colors -->
    <div class="top-row-grid">

        <!-- App Details Card -->
        <div class="section-card">
        <div class="card-header">
            <h3>{{ 'App Details' | translate }}</h3>
        </div>
        <div class="card-body">
            <div class="fields-grid" [class.fields-grid-3]="!this.vendor.isVendor">

            <!-- App Name / Vendor Name -->
            <div class="field-wrapper">
                <div class="field-label-row">
                <label *ngIf="!this.vendor.isVendor">{{ 'App Name' | translate }}</label>
                <label *ngIf="this.vendor.isVendor">{{ 'Vendor Name' | translate }}</label>
                </div>
                <div class="genie-input">
                <input type="text" formControlName="application_name" [placeholder]="'Stacks App' | translate" >
                </div>
            </div>

            <!-- Package Name -->
            <div class="field-wrapper" *ngIf="!this.vendor.isVendor">
                <div class="field-label-row">
                <label>{{ 'Package Name' | translate }}</label>
                </div>
                <div class="genie-input">
                <input type="text" formControlName="package_name" placeholder="com.stacks.app" pattern="^[a-z][a-z0-9_]*(\.[a-z0-9_]+)+[0-9a-z_]$">
                </div>
            </div>

            <!-- IPA SKU Number -->
            <div class="field-wrapper" *ngIf="!this.vendor.isVendor">
                <div class="field-label-row">
                <label>{{ 'IPA SKU Number' | translate }}</label>
                </div>
                <div class="genie-input">
                <input type="text" formControlName="ipa_sku_number" [placeholder]="'SKU-001-APP' | translate">
                </div>
            </div>

            <!-- App Type (Admin Only) -->
            <div class="field-wrapper" *ngIf="loginService.getCurrentUser()?.admin">
                <div class="field-label-row">
                <label>{{ 'App Type' | translate }}</label>
                </div>
                <div class="genie-input">
                <select formControlName="release_app">
                    <option value="yes">{{ 'Release' | translate }}</option>
                    <option value="no">{{ 'Debug' | translate }}</option>
                </select>
                </div>
            </div>

            <!-- Project Type (Admin Only) -->
            <div class="field-wrapper" *ngIf="loginService.getCurrentUser()?.admin">
                <div class="field-label-row">
                <label>{{ 'Project Type' | translate }}</label>
                </div>
                <div class="genie-input">
                <select formControlName="project_type">
                    <option value="">{{ 'Normal' | translate }}</option>
                    <option value="vendor">{{ 'Vendor' | translate }}</option>
                    <option value="multi-vendor">{{ 'Multi-Vendor' | translate }}</option>
                </select>
                </div>
            </div>

            </div>
        </div>
        </div>

        <!-- Theme Colors Card -->
        <div class="section-card">
            <div class="card-header">
                <h3>{{ 'Theme Colors' | translate }}</h3>
            </div>
            <div class="card-body">
                <div class="fields-grid">
                    <!-- Primary Color -->
                    <div class="field-wrapper">
                        <div class="field-label-row"><label>{{ 'Primary Color' | translate }}</label></div>
                        <div class="color-input-container">
                             <div class="color-preview" [style.background-color]="settingsForm.get('mobile_primary_color')?.value">
                                <input type="color" formControlName="mobile_primary_color" (change)="colorChange($event, 'mobile_primary_color')">
                             </div>
                             <div class="genie-input color-text-input">
                                 <input type="text" [value]="(settingsForm.get('mobile_primary_color')?.value || settingsForm.get('mobile_primary_color')?.value) | uppercase" readonly>
                                 <span class="opacity-badge"><span class="color_hundred">100 </span> %</span>
                             </div>
                        </div>
                    </div>

                    <!-- Secondary Color -->
                    <div class="field-wrapper">
                        <div class="field-label-row"><label>{{ 'Secondary Color' | translate }}</label></div>
                        <div class="color-input-container">
                             <div class="color-preview" [style.background-color]="settingsForm.get('mobile_secondary_color')?.value">
                                <input type="color" formControlName="mobile_secondary_color" (change)="colorChange($event, 'mobile_secondary_color')">
                             </div>
                             <div class="genie-input color-text-input">
                                 <input type="text" [value]="(settingsForm.get('mobile_secondary_color')?.value || settingsForm.get('mobile_secondary_color')?.value) | uppercase" readonly>
                                 <span class="opacity-badge"><span class="color_hundred">100 </span> %</span>
                             </div>
                        </div>
                    </div>

                     <!-- Button Text Color -->
                     <div class="field-wrapper">
                        <div class="field-label-row"><label>{{ 'Button Text Color' | translate }}</label></div>
                        <div class="color-input-container">
                             <div class="color-preview" [style.background-color]="settingsForm.get('button_text_color')?.value">
                                <input type="color" formControlName="button_text_color" (change)="colorChange($event, 'button_text_color')">
                             </div>
                             <div class="genie-input color-text-input">
                                 <input type="text" [value]="(settingsForm.get('button_text_color')?.value || settingsForm.get('button_text_color')?.value) | uppercase" readonly>
                                 <span class="opacity-badge"><span class="color_hundred">100 </span> %</span>
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!-- Assets & Branding Card -->
    <div class="section-card" *ngIf="!this.vendor.isVendor">
      <div class="card-header">
        <h3>{{ 'Assets & Branding' | translate }}</h3>
      </div>
      <div class="card-body">
        <div class="upload-grid">

          <!-- App Icon -->
          <div class="upload-item">
            <div class="label-row">
              <label>{{ 'App Icon' | translate }}</label>
            </div>
            <div class="upload-area">
              <input type="file" formControlName="icon" accept="image/png" (change)="this.processFile($event, 'icon', 1024, 1024)" />

              <div *ngIf="generalSettingsData?.icon" style="text-align:center; z-index: 1;">
                 <img [src]="generalSettingsData?.icon" style="width: 64px; height: 64px; border-radius: 12px; object-fit: cover; margin-bottom: 8px;">
                 <div class="upload-text">{{ 'Click to Change' | translate }}</div>
                 <div class="upload-hint">{{ 'SVG, PNG or JPG ( Max 2 mb )' | translate }}<br>{{ 'Dimensions: 1024*1024' | translate }}</div>
              </div>

              <div *ngIf="!generalSettingsData?.icon" style="display:flex; flex-direction:column; align-items:center;">
                  <div class="upload-icon-circle">
                    <svg width="40" height="40" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="3.33301" y="3.33398" width="40" height="40" rx="20" fill="#ECF5F8" />
                      <path d="M20 26.6673L23.3333 23.334M23.3333 23.334L26.6667 26.6673M23.3333 23.334V30.834M30 27.2863C31.0179 26.4457 31.6667 25.1739 31.6667 23.7507C31.6667 21.2193 29.6146 19.1673 27.0833 19.1673C26.9012 19.1673 26.7309 19.0723 26.6384 18.9154C25.5517 17.0713 23.5454 15.834 21.25 15.834C17.7982 15.834 15 18.6322 15 22.084C15 23.8057 15.6962 25.3649 16.8225 26.4953" stroke="#3B82F6" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <div class="upload-text">{{ 'click to Upload' | translate }}</div>
                  <div class="upload-hint">{{ 'SVG, PNG or JPG ( Max 2 mb )' | translate }}<br>{{ 'Dimensions: 1024*1024' | translate }}</div>
              </div>
            </div>
          </div>

          <!-- Splash Screen -->
          <div class="upload-item">
            <div class="label-row">
              <label>{{ 'Splash Screen' | translate }}</label>
            </div>
            <div class="upload-area">
              <input type="file" accept="image/png" formControlName="splash_screen" (change)="this.processFile($event, 'splash_screen', 2732, 2732)" />

              <div *ngIf="generalSettingsData?.splash_screen" style="text-align:center; z-index: 1;">
                <img [src]="generalSettingsData?.splash_screen" style="max-height: 80px; max-width: 100%; object-fit: contain; margin-bottom: 8px;">
                <div class="upload-text">{{ 'Click to Change' | translate }}</div>
                <div class="upload-hint">{{ 'SVG, PNG or JPG ( Max 2 mb )' | translate }}<br>{{ 'Dimensions: 2732*2732' | translate }}</div>
             </div>

             <div *ngIf="!generalSettingsData?.splash_screen" style="display:flex; flex-direction:column; align-items:center;">
                <div class="upload-icon-circle">
                  <svg width="40" height="40" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3.33301" y="3.33398" width="40" height="40" rx="20" fill="#ECF5F8" />
                    <path d="M20 26.6673L23.3333 23.334M23.3333 23.334L26.6667 26.6673M23.3333 23.334V30.834M30 27.2863C31.0179 26.4457 31.6667 25.1739 31.6667 23.7507C31.6667 21.2193 29.6146 19.1673 27.0833 19.1673C26.9012 19.1673 26.7309 19.0723 26.6384 18.9154C25.5517 17.0713 23.5454 15.834 21.25 15.834C17.7982 15.834 15 18.6322 15 22.084C15 23.8057 15.6962 25.3649 16.8225 26.4953" stroke="#3B82F6" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <div class="upload-text">{{ 'click to Upload' | translate }}</div>
                <div class="upload-hint">{{ 'SVG, PNG or JPG ( Max 2 mb )' | translate }}<br>{{ 'Dimensions: 2732*2732' | translate }}</div>
             </div>
            </div>
          </div>

          <!-- Animated Splash -->
          <div class="upload-item">
            <div class="label-row">
              <label>{{ 'Animated Splash' | translate }}</label>
              <!-- Toggle Switch -->
              <label class="toggle-switch">
                  <input type="checkbox" [(ngModel)]="enableAnimatedSplash" [ngModelOptions]="{ standalone: true }" (change)="toggleAnimatedSplash()" />
                  <span class="toggle-slider"></span>
              </label>
            </div>
            <div class="upload-area" [style.opacity]="enableAnimatedSplash ? '1' : '0.5'" [style.cursor]="enableAnimatedSplash ? 'pointer' : 'not-allowed'">
              <input type="file" accept="image/gif" formControlName="animated_splash" (change)="processFile($event, 'animated_splash', 2732, 2732)" [disabled]="!enableAnimatedSplash" [style.pointer-events]="enableAnimatedSplash ? 'auto' : 'none'" />

              <div *ngIf="generalSettingsData?.animated_splash" style="text-align:center; z-index: 1;">
                <img [src]="generalSettingsData?.animated_splash" style="max-height: 80px; max-width: 100%; object-fit: contain; margin-bottom: 8px;">
                <div class="upload-text">{{ 'Click to Change' | translate }}</div>
                <div class="upload-hint">{{ 'gif ( Max 5 mb )' | translate }}<br>{{ 'ratio 9:16' | translate }}</div>
             </div>

             <div *ngIf="!generalSettingsData?.animated_splash" style="display:flex; flex-direction:column; align-items:center;">
                <div class="upload-icon-circle">
                  <svg width="40" height="40" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3.33301" y="3.33398" width="40" height="40" rx="20" fill="#ECF5F8" />
                    <path d="M20 26.6673L23.3333 23.334M23.3333 23.334L26.6667 26.6673M23.3333 23.334V30.834M30 27.2863C31.0179 26.4457 31.6667 25.1739 31.6667 23.7507C31.6667 21.2193 29.6146 19.1673 27.0833 19.1673C26.9012 19.1673 26.7309 19.0723 26.6384 18.9154C25.5517 17.0713 23.5454 15.834 21.25 15.834C17.7982 15.834 15 18.6322 15 22.084C15 23.8057 15.6962 25.3649 16.8225 26.4953" stroke="#3B82F6" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <div class="upload-text">{{ 'click to Upload' | translate }}</div>
                <div class="upload-hint">{{ 'gif ( Max 5 mb )' | translate }}<br>{{ 'ratio 9:16' | translate }}</div>
             </div>
            </div>
            <!-- Duration Input if animated splash is on -->
             <div class="duration-container" [class.open]="enableAnimatedSplash">
                <div class="field-wrapper">
                    <div class="field-label-row"><label>{{ 'Duration (ms)' | translate }}</label></div>
                    <div class="genie-input">
                        <input type="number" placeholder="6000" formControlName="animated_splash_duration">
                    </div>
                </div>
             </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Hidden Tour Button to preserve logic if necessary -->
    <button *ngIf="this.builderService.getTour()" id="tourNextAction" style="display:none" type="button" (click)="generalSettingsNext()">
      {{ 'Next' | translate }}
    </button>

  </div>
</form>
